import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import Calendar from 'react-calendar';
import useStyles from './Styles';


interface Props {
    close():void,
    change(dt:string):void,
    value:string,
    isOpen:boolean,
}

const DatePick = (props:Props)=> {
    const classes = useStyles();

    const changeDate = (date:Date | Date[])=>{
        const dt = date.toLocaleString().split(" ");
        //console.log(dt[0]);
        props.change(dt[0]);
    }

    let date:Date = new Date();
    if( props.value ){
        if(props.value.match(/^\d{4}[-\/]\d{1,2}[\/-]\d{1,2}$/)){
            const sp = props.value.split(/[-\/]/);
            if( parseInt(sp[0])>2000 && parseInt(sp[0])<2100 && parseInt(sp[1])>0 && parseInt(sp[1])<13 && parseInt(sp[2])>0 && parseInt(sp[2])<32 ){
                date = new Date(props.value);
            }
        }
    }

    return (
        <Dialog
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={props.isOpen}
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
        >
			<DialogTitle color='primary'>日付選択</DialogTitle>
			<DialogContent>
            	<Calendar onChange={changeDate} value={date}/>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='閉じる' onClick1={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
    );
}

export default DatePick;
